import gql from 'graphql-tag';
import { matchPlayerFragment } from './matchPlayer';
import { teamFragment } from './team';
import { competitionFragment } from './competition';
import { summaryFragment } from './summary';
export const fullMatchFragment = gql `
  fragment FullMatch on Match {
    id
    date
    name
    sportName
    config
    competitionId
    finishedStatus
    liveStatus
    hasFacts
    sportName
    summary {
      ...Summary
    }
    lineup {
      ...MatchPlayer
    }
    homeTeam {
      ...Team
    }
    awayTeam {
      ...Team
    }
    competition {
      ...CompetitionWithAdAllocation
    }
    venue {
      id
      name
    }
  }
  ${competitionFragment}
  ${matchPlayerFragment}
  ${teamFragment}
  ${summaryFragment}
`;
export const fullMatchUpdateFragment = gql `
  fragment FullMatchUpdate on Match {
    id
    date
    name
    sportName
    config
    competitionId
    finishedStatus
    liveStatus
    hasFacts
    sportName
    summary {
      ...Summary
    }
    lineup {
      ...MatchPlayer
    }
    homeTeam {
      ...Team
    }
    awayTeam {
      ...Team
    }
    competition {
      ...CompetitionWithAdAllocation
    }
    venue {
      id
      name
    }
  }
  ${competitionFragment}
  ${matchPlayerFragment}
  ${teamFragment}
  ${summaryFragment}
`;
//# sourceMappingURL=match.js.map